<form [formGroup]="searchForm">
    <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px">

        <div fxFlex='15' fxFlex.lt-md='100'>
            <date-input-ctrl [settings]="{fxFill:true}" [caption]="'claims-center.claimMessages.sentFromDate'"
                [formControlName]="'sentFromDate'">
            </date-input-ctrl>
        </div>
        <div fxFlex='15' fxFlex.lt-md='100'>
            <date-input-ctrl [settings]="{fxFill:true}" [caption]="'claims-center.claimMessages.sentToDate'"
                [formControlName]="'sentToDate'">
            </date-input-ctrl>
        </div>
        <div fxFlex='30' fxFlex.lt-md='100'>
            <text-input-ctrl [caption]="'claims-center.claimMessages.searchText'" [formControlName]="'text'"
                [settings]="{ fxFill: true }">
            </text-input-ctrl>
        </div>

        <div fxLayoutAlign="space-between center" fxLayoutGap="10px">
            <button kendoButton (click)="searchAndResetPagesClick()" icon="search" type="submit"> </button>
        </div>
    </div>
</form>


<kendo-grid [data]="view | async" [loading]="this.loading" [pageSize]="rowsPerPage$ | async" [skip]="skip$ | async"
    [pageable]="true" [rowSelected]="isRowSelected" [selectable]="selectableSettings" scrollable="none"
    serverPaging="true" (dataStateChange)="dataStateChange($event)" (pageChange)="pageChange($event)" [size]="'small'">

    <kendo-grid-column field="sentDate" title="{{'claims-center.claimMessages.sentDate' | translate}}" [width]="20">
        <ng-template kendoGridCellTemplate let-message="dataItem">
            <strong>{{message.timestamp | date:'yyyy-MM-dd HH:mm:ss' }}</strong>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="recipients" title="{{'claims-center.claimMessages.recipients' | translate}}" [width]="20">
        <ng-template kendoGridCellTemplate let-message="dataItem">
            <div *ngFor="let recipient of message.recipients">
                <div fxLayoutGap="5px" class="small-info">
                        <strong>{{recipient.recipientInfo}}</strong>   
                        -<span>{{recipient.recipientRole | staticDictionaryCaption:'recipientRole' |async }}</span>
                </div>
            </div>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="claimInfo" title="{{'claims-center.claimMessages.claimInfo' | translate}}" [width]="20">
        <ng-template kendoGridCellTemplate let-message="dataItem">
            <div fxLayout="column">
                <span>{{message.contactInfo}}</span>
                <span>{{message.contactPhoneNumber}}</span>
                <span class="small-info">{{message.claimNumber}} </span>
                <span class="small-info">{{message.claimCarInfo}} </span>
                <span class="small-info">{{message.claimCarVin}} </span>
                <strong class="small-info">{{message.orderingPartyName}} </strong>
            </div>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="messageInfo" title="{{'claims-center.claimMessages.messageInfo' | translate}}"
        [width]="500">
        <ng-template kendoGridCellTemplate let-message="dataItem">
            <div fxLayoutAlign="start center">
                <div fxLayout="column" class="message-box" fxFlex="300">

                    <div fxLayout="row">
                        <!-- <app-sending-channel-icon [sendingChannel]="message.sendingChannelTypeId"
                            [size]="24"></app-sending-channel-icon> -->
                        <kendo-icon *ngIf="message.isPriority" name="exclamation-circle" themeColor="error" class="priority-icon"
                            title="{{'claims-center.claimMessages.isPriority' | translate}}"></kendo-icon>
                        <strong>{{ message.title }}</strong>
                        <div class="message-info">
                            - <span [title]="message.createdBy">{{ message.senderInfo}}</span> <strong>
                                ({{ message.senderRoleId | staticDictionaryCaption:'recipientRole' |async}})</strong>
                            - {{message.timestamp | date:'yyyy-MM-dd HH:mm:ss' }}
                        </div>
                    </div>

                    <div fxLayout="row wrap">
                        <div>
                            <span>{{ message.contentText }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="claimInfo" title="{{'claims-center.claimMessages.actions' | translate}}" [width]="20">
        <ng-template kendoGridCellTemplate let-message="dataItem">
            <button type="button" kendoButton (click)="doService(message)">
                <img src="./assets/img/communication.png" [width]='16' alt="communication" />
                {{'claims-center.claimMessages.goToMessageThread' | translate}}</button>
        </ng-template>
    </kendo-grid-column>

</kendo-grid>